/*
 Created by CHT 2019/12/4 10:53
 筛选按钮（筛选控件）
*/

import BaseChart from "../BaseChart"
import {CHART_CATEGORY__FILTER, CHART_TYPE__FILTER_BTN} from "../types"

class FilterBtn extends BaseChart {
  constructor() {
    super()

    this.chartName = '筛选'

    this.w = 10
    this.h = 2
    // 最小宽
    this.minW = 4
    // 最小高
    this.minH = 1
    this.maxH = 5
    this.maxW = 15

    this.toEdit = false
  }

  get title() {
    return this.chartName || MediaChart._title
  }

  set title(content) {
    this.chartName = content
  }
}

FilterBtn._title = '筛选'
FilterBtn.type = CHART_TYPE__FILTER_BTN

FilterBtn.prototype.chartCategory = CHART_CATEGORY__FILTER
FilterBtn.prototype.chartType = FilterBtn.type

export default FilterBtn
